// extracted by mini-css-extract-plugin
export default {"block":"Drawer_block__R7s06","item":"Drawer_item__nZrqj"};